import { esc } from "../ui/format.js";

/**
 * The radar of the chart kit (2.7): the Company Health radar on Overview and uiRadar in the section kit both draw
 * with this one function (Overview used to hand-draw its own on a canvas).
 */
/** Radar chart (inline SVG): axes [{axis, weight 0-100}]. */
function svgRadar(axes, { size = 240, caption = "" } = {}) {
  if (!axes || axes.length < 3) return "";
  const c = size / 2, r = size / 2 - 34, n = axes.length;
  const pt = (i, v) => {
    const a = -Math.PI / 2 + (i * 2 * Math.PI) / n;
    return [c + Math.cos(a) * r * v, c + Math.sin(a) * r * v];
  };
  const rings = [0.25, 0.5, 0.75, 1].map((k) =>
    `<polygon points="${axes.map((_, i) => pt(i, k).join(",")).join(" ")}" class="sx-radar-ring"/>`).join("");
  const spokes = axes.map((_, i) => `<line x1="${c}" y1="${c}" x2="${pt(i, 1)[0]}" y2="${pt(i, 1)[1]}" class="sx-radar-ring"/>`).join("");
  const shape = axes.map((a, i) => pt(i, Math.max(0, Math.min(100, a.weight)) / 100).join(",")).join(" ");
  const labels = axes.map((a, i) => {
    const [x, y] = pt(i, 1.2);
    return `<text x="${x}" y="${y}" text-anchor="middle" dominant-baseline="middle" class="sx-radar-label">${esc(a.axis)} <tspan class="sx-radar-num">${a.weight}</tspan></text>`;
  }).join("");
  return `<figure class="sx-radar">${caption ? `<figcaption>${esc(caption)}</figcaption>` : ""}
    <svg viewBox="-40 0 ${size + 80} ${size}" width="100%" style="max-width:${size + 80}px" role="img" aria-label="${esc(caption || "radar chart")}">
      ${rings}${spokes}<polygon points="${shape}" class="sx-radar-shape"/>${labels}</svg></figure>`;
}

export { svgRadar };
